module.exports = __webpack_public_path__ + "o.no1.4f6a4a9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/o.no1.jpg
// module id = wcin
// module chunks = 0